import {
  STATUS_ABGEGEBEN,
  STATUS_ABGESCHLOSSEN,
  STATUS_AKZEPTIERT,
  STATUS_CUSTOM,
  STATUS_DURCHGEFUEHRT,
  STATUS_GEBUCHT,
  STATUS_IM_AUFBAU,
  STATUS_IN_ARBEIT,
  STATUS_NEUER_TERMIN,
  STATUS_NICHT_ANGETROFFEN,
  STATUS_NONE,
  STATUS_OFFEN,
  STATUS_STORNIERT,
  STATUS_UEBERFAELLIG,
} from '../constants/status-constants';
import { StatusHistory } from '../../status-history/models/status-history.model';
import { HistoryStatus } from '@modules/sales/enums/history-status.enum';

export class StatusHistoryMapper {
  public getByGuid(id: string): HistoryStatus {
    switch (id.toUpperCase()) {
      case STATUS_UEBERFAELLIG:
        return HistoryStatus.Ueberfaellig;
      case STATUS_OFFEN:
        return HistoryStatus.Offen;
      case STATUS_IN_ARBEIT:
        return HistoryStatus.In_Arbeit;
      case STATUS_DURCHGEFUEHRT:
        return HistoryStatus.Durchgefuehrt;
      case STATUS_ABGESCHLOSSEN:
        return HistoryStatus.Abgeschlossen;
      case STATUS_NICHT_ANGETROFFEN:
        return HistoryStatus.Nicht_Angetroffen;
      case STATUS_NEUER_TERMIN:
        return HistoryStatus.Neuer_Termin;
      case STATUS_CUSTOM:
        return HistoryStatus.Custom;
      case STATUS_IM_AUFBAU:
        return HistoryStatus.Im_Aufbau;
      case STATUS_NONE:
        return HistoryStatus.None;
      case STATUS_AKZEPTIERT:
        return HistoryStatus.Akzeptiert;
      case STATUS_STORNIERT:
        return HistoryStatus.Storniert;
      case STATUS_GEBUCHT:
        return HistoryStatus.Gebucht;
      case STATUS_ABGEGEBEN:
        return HistoryStatus.Abgegeben;
      default:
        return HistoryStatus.Offen;
    }
  }

  public getGuid(status: HistoryStatus): string {
    switch (status) {
      case HistoryStatus.Abgeschlossen:
        return STATUS_ABGESCHLOSSEN;
      case HistoryStatus.Akzeptiert:
        return STATUS_AKZEPTIERT;
      case HistoryStatus.Custom:
        return STATUS_CUSTOM;
      case HistoryStatus.Durchgefuehrt:
        return STATUS_DURCHGEFUEHRT;
      case HistoryStatus.Im_Aufbau:
        return STATUS_IM_AUFBAU;
      case HistoryStatus.In_Arbeit:
        return STATUS_IN_ARBEIT;
      case HistoryStatus.Neuer_Termin:
        return STATUS_NEUER_TERMIN;
      case HistoryStatus.Nicht_Angetroffen:
        return STATUS_NICHT_ANGETROFFEN;
      case HistoryStatus.None:
        return STATUS_NONE;
      case HistoryStatus.Offen:
        return STATUS_OFFEN;
      case HistoryStatus.Storniert:
        return STATUS_STORNIERT;
      case HistoryStatus.Ueberfaellig:
        return STATUS_UEBERFAELLIG;
      case HistoryStatus.Gebucht:
        return STATUS_GEBUCHT;
      case HistoryStatus.Abgegeben:
        return STATUS_ABGEGEBEN;
      default:
        return STATUS_OFFEN;
    }
  }

  public getShortDesc(status: HistoryStatus): string {
    switch (status) {
      case HistoryStatus.Abgeschlossen:
        return 'Erled.';
      case HistoryStatus.Akzeptiert:
        return 'Akzeptiert';
      case HistoryStatus.Custom:
        return '?';
      case HistoryStatus.Durchgefuehrt:
        return 'Durchg.';
      case HistoryStatus.Im_Aufbau:
        return 'i.A.';
      case HistoryStatus.In_Arbeit:
        return 'in Arb.';
      case HistoryStatus.Neuer_Termin:
        return 'NT';
      case HistoryStatus.Nicht_Angetroffen:
        return 'NA';
      case HistoryStatus.None:
        return '';
      case HistoryStatus.Offen:
        return 'Offen';
      case HistoryStatus.Storniert:
        return 'Storniert';
      case HistoryStatus.Ueberfaellig:
        return 'Überf.';
      case HistoryStatus.Gebucht:
        return 'Gebucht';
      case HistoryStatus.Abgegeben:
        return 'Abgeg.';
      default:
        return 'Offen';
    }
  }

  public getLongDesc(status: HistoryStatus): string {
    switch (status) {
      case HistoryStatus.Abgeschlossen:
        return 'abgeschlossen';
      case HistoryStatus.Akzeptiert:
        return 'Akzeptiert';
      case HistoryStatus.Custom:
        return '';
      case HistoryStatus.Durchgefuehrt:
        return 'durchgeführt';
      case HistoryStatus.Im_Aufbau:
        return 'Im Aufbau';
      case HistoryStatus.In_Arbeit:
        return 'In Arbeit';
      case HistoryStatus.Neuer_Termin:
        return 'neuer Termin';
      case HistoryStatus.Nicht_Angetroffen:
        return 'nicht angetroffen';
      case HistoryStatus.None:
        return '';
      case HistoryStatus.Offen:
        return 'Offen';
      case HistoryStatus.Storniert:
        return 'Storniert';
      case HistoryStatus.Ueberfaellig:
        return 'überfällig';
      case HistoryStatus.Gebucht:
        return 'Gebucht';
      case HistoryStatus.Abgegeben:
        return 'Abgegeben';
      default:
        return 'Offen';
    }
  }

  public getColor(status: HistoryStatus, isLight = true): string {
    switch (status) {
      case HistoryStatus.Abgeschlossen:
      case HistoryStatus.Gebucht:
        if (isLight) return 'var(--grey-color, #9C9E9F)';
        else return 'var(--grey-dark-color, #292828)';

      case HistoryStatus.Akzeptiert:
      case HistoryStatus.Custom:
      case HistoryStatus.Im_Aufbau:
      case HistoryStatus.In_Arbeit:
      case HistoryStatus.Neuer_Termin:
      case HistoryStatus.None:
      case HistoryStatus.Offen:
      case HistoryStatus.Abgegeben:
        if (isLight) return 'var(--yellow-color, #FCEA0D)';
        else return 'var(--yellow-dark-color, #756c02)';

      case HistoryStatus.Durchgefuehrt:
        return 'var(--green-color, #41A62A)';

      case HistoryStatus.Nicht_Angetroffen:
      case HistoryStatus.Ueberfaellig:
        if (isLight) return 'var(--orange-color, #F29400)';
        else return 'var(--orange-dark-color, #C97E05)';

      case HistoryStatus.Storniert:
        return 'var(--red-color, #FF0000)';

      default:
        return 'var(--yellow-color, #FCEA0D)';
    }
  }

  public mapStatusHistoryRequest(data: StatusHistory) {
    const request = {
      UId: data.uId,
      StatusId: data.statusId,
      InfoDesc: data.infoDesc,
      ShortDesc: data.shortDesc,
      EmployeeDesc: data.employeeDesc,
      TaskId: data.taskId,
      ReportId: data.reportId,
      ProjectId: data.projectId,
      StampCreate: data.stampCreate,
    };

    return request;
  }
}
